// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*==== Hero area classes ====*/
.hero-search {
    width: 100%;
    min-height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background-image: var(--gradientclr); */
    color: #fff;
}
.hero-search.inner-page{
    min-height: 67px;
    /* background: var(--orange); */
    background-image: unset;
}
.hero-search h2 {
    font-weight: 700;
    font-size: 32px;
    line-height: 40px;
    text-align: center;
    text-shadow: 0px 4px 16px rgba(126, 133, 142, 0.16);
    margin-bottom: 10px;
}
.hero-search-modified {
    width: 100%;
    min-height: 180px;
    display: flex;
    align-items: center;
    justify-content: center;
    /* background-image: var(--gradientclr); */
    color: #000000;
}
.hero-search-modified.inner-page{
    min-height: 54px;
    /* background: var(--orange); */
    background-image: unset;
}
.hero-search-modified h2 {
    font-weight: 600;
    /* font-size: 32px; */
    font-size: 15px;
    line-height: 40px;
    /* text-align: center; */
    text-shadow: 0px 4px 16px rgba(126, 133, 142, 0.16);
    /* margin-bottom: 10px; */
    padding: 3px 0px;
}


.hero-search-modified .three_bars {
    font-size: 30px;
    cursor: pointer;
    
}
 .newBar{
    
    cursor: pointer;
    
}
.hero-search-modified .category_div {
    padding: 0px 30px;
}
/* .dropdown:hover>.dropdown-menu {
  display: block;
  max-height: 300px;
} */
.dropdown>.dropdown-toggle:active {
  /*Without this, clicking will make it sticky*/
    /* pointer-events: none; */
}

.dropdown-toggle::after {
  display: none;
}
.hero-search-modified.inner-page .dropdown-menu::before {
    content: "";
    width: 100%;
    height: 30px;
    background: transparent;
    position: absolute;
    top: -30px;
}
.search-bar .form-control {
    border: 1.5px solid rgba(122, 137, 146, 0.5);
    border-radius: 8px;
    height: 40px;
    padding-left: 50px;
    padding-right: 30px;
}

.form-control:focus {
  border-color:rgba(122, 137, 146, 0.5) !important; /* Set the desired border color on focus */
  
}
.search-bar {
    position: relative;
    width: 100%;
    margin-right: 15px;
    /* max-width: 630px; */
    max-width: 100%;
}
.search-bar .search-icon {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    color: #333;
    left: 20px;
    font-size: 14px;
}
.search-content {
    display: flex;
    align-items: center;
    justify-content: center;
}
.search-bar .form-control::placeholder {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: rgba(126, 133, 142, 0.6);
    opacity: 0.8;
} 
.categories-search {
    display: flex;
    align-items: center;
    justify-content: center;
}

.categories-searchh {
    display: flex;
    align-items: center;
    /* justify-content: center; */
    margin-bottom: 5px;
}
.categories-area {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    overflow-y: auto;
    max-height: 400px;
}

.category-btn {
    font-weight: 600;
    font-size: 16px;
    line-height: 24px;
    color: #fff;
    min-width: 150px;
    /* text-align: strat; */
    margin-bottom: 10px;
    cursor: pointer;
}
.category-bttn {
    font-weight: 400;
    font-size: 14px;
    line-height: 24px;
    color: #fff;
    min-width: 150px;
    /* text-align: strat; */
    /* margin-bottom: 10px; */
    cursor: pointer;
}
.category-bttnn{
    font-weight: 400;
    font-size: 15px;
    line-height: 24px;
    /* min-width: 150px; */
    /* text-align: strat; */
    margin-bottom: 15px;
    cursor: pointer;
}

.btn.category-btn:hover {
    color: var(--blue)!important;
}
.category-btn i {
    font-size: 10px;
    margin-left: 10px;
}
.categories-search {
    margin-top: 15px;
}
.container{
    /* background-color: rgba(0,0,0,0.5); */
  z-index: 2;
}

/*==== Min Width media query ====*/

@media only screen and (min-width: 576px){

}

@media only screen and (min-width: 768px){
  
}

@media only screen and (min-width: 992px){
 .category-modal .modal-dialog {
        max-width: 652px;
 } 
}

@media only screen and (min-width: 1201px){
  
}

/*==== Min & Max Width media query ====*/
@media only screen and (min-width: 767px) and (max-width: 1200px){
  .listing-bottom-right h6 {
        font-size: 18px;
    }
    .listing-bottom-right h6 span{
        font-size: 18px!important;
    }
  .listing-bottom-right-giftcards h6 {
        font-size: 18px;
    }
    .listing-bottom-right-giftcards h6 span{
        font-size: 18px!important;
    }
    .inputwithunit .form-control, .inputwithunit span {
        font-size: 16px;
    }
}

/*==== Max Width media query ====*/

@media only screen and (max-width: 1200px){
  
}

@media only screen and (max-width: 991px){
}

@media only screen and (max-width: 767px){ 
}

@media only screen and (max-width: 575px){

}
@media screen and (min-width:992px) and (max-width:1200px) {
    .category-btn{
        margin-bottom: 60px !important;
        margin-right: 87px !important;
    } 
}

@media only screen and (max-width: 425px){
.search-content {
    display: block;
}
.search-content .btn {
    width: 100%;
    margin-top: 10px;
}
.category-btn {
    text-align: center;
}
}
.dropdown {
    position: relative;
    display: inline-block;
}

.dropdown-content {
    display: none;
    position: absolute;
    background-color: #f9f9f9;
    min-width: 200px;
    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
    padding: 10px;
    z-index: 1;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(10, auto);
    grid-gap: 5px;
    list-style: none;
}

.dropdown:hover .dropdown-content {
    display: grid;
}

.dropdown-content a {
    color: black;
    padding: 8px 16px;
    text-decoration: none;
    display: block;
}

.dropdown-content a:hover {
    background-color: #f1f1f1;
}

@media (max-width: 576px) {
    .dropdown-content {
        max-height: 400px; 
        min-width: 100%; 
        display: block; 
        grid-template-columns: none;
        grid-template-rows: none; 
        overflow: auto;
    }
    .dropdown-content li {
        display: block; 
    }
}
`, "",{"version":3,"sources":["webpack://./src/styles/herobanner.css"],"names":[],"mappings":"AAAA,8BAA8B;AAC9B;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,mDAAmD;IACnD,mBAAmB;AACvB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,0CAA0C;IAC1C,cAAc;AAClB;AACA;IACI,gBAAgB;IAChB,+BAA+B;IAC/B,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,mDAAmD;IACnD,yBAAyB;IACzB,gBAAgB;AACpB;;;AAGA;IACI,eAAe;IACf,eAAe;;AAEnB;CACC;;IAEG,eAAe;;AAEnB;AACA;IACI,iBAAiB;AACrB;AACA;;;GAGG;AACH;EACE,6CAA6C;IAC3C,0BAA0B;AAC9B;;AAEA;EACE,aAAa;AACf;AACA;IACI,WAAW;IACX,WAAW;IACX,YAAY;IACZ,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd;AACA;IACI,4CAA4C;IAC5C,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;EACE,gDAAgD,EAAE,0CAA0C;;AAE9F;AACA;IACI,kBAAkB;IAClB,WAAW;IACX,kBAAkB;IAClB,sBAAsB;IACtB,eAAe;AACnB;AACA;IACI,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,UAAU;IACV,eAAe;AACnB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,+BAA+B;IAC/B,YAAY;AAChB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,uBAAuB;IACvB,yBAAyB;IACzB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,4BAA4B;AAChC;AACA;IACI,eAAe;IACf,iBAAiB;AACrB;AACA;IACI,gBAAgB;AACpB;AACA;IACI,uCAAuC;EACzC,UAAU;AACZ;;AAEA,kCAAkC;;AAElC;;AAEA;;AAEA;;AAEA;;AAEA;CACC;QACO,gBAAgB;CACvB;AACD;;AAEA;;AAEA;;AAEA,wCAAwC;AACxC;EACE;QACM,eAAe;IACnB;IACA;QACI,yBAAyB;IAC7B;EACF;QACM,eAAe;IACnB;IACA;QACI,yBAAyB;IAC7B;IACA;QACI,eAAe;IACnB;AACJ;;AAEA,kCAAkC;;AAElC;;AAEA;;AAEA;AACA;;AAEA;AACA;;AAEA;;AAEA;AACA;IACI;QACI,8BAA8B;QAC9B,6BAA6B;IACjC;AACJ;;AAEA;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,gBAAgB;AACpB;AACA;IACI,kBAAkB;AACtB;AACA;AACA;IACI,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,gBAAgB;IAChB,4CAA4C;IAC5C,aAAa;IACb,UAAU;IACV,qCAAqC;IACrC,oCAAoC;IACpC,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,iBAAiB;IACjB,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI;QACI,iBAAiB;QACjB,eAAe;QACf,cAAc;QACd,2BAA2B;QAC3B,wBAAwB;QACxB,cAAc;IAClB;IACA;QACI,cAAc;IAClB;AACJ","sourcesContent":["/*==== Hero area classes ====*/\n.hero-search {\n    width: 100%;\n    min-height: 180px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    /* background-image: var(--gradientclr); */\n    color: #fff;\n}\n.hero-search.inner-page{\n    min-height: 67px;\n    /* background: var(--orange); */\n    background-image: unset;\n}\n.hero-search h2 {\n    font-weight: 700;\n    font-size: 32px;\n    line-height: 40px;\n    text-align: center;\n    text-shadow: 0px 4px 16px rgba(126, 133, 142, 0.16);\n    margin-bottom: 10px;\n}\n.hero-search-modified {\n    width: 100%;\n    min-height: 180px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    /* background-image: var(--gradientclr); */\n    color: #000000;\n}\n.hero-search-modified.inner-page{\n    min-height: 54px;\n    /* background: var(--orange); */\n    background-image: unset;\n}\n.hero-search-modified h2 {\n    font-weight: 600;\n    /* font-size: 32px; */\n    font-size: 15px;\n    line-height: 40px;\n    /* text-align: center; */\n    text-shadow: 0px 4px 16px rgba(126, 133, 142, 0.16);\n    /* margin-bottom: 10px; */\n    padding: 3px 0px;\n}\n\n\n.hero-search-modified .three_bars {\n    font-size: 30px;\n    cursor: pointer;\n    \n}\n .newBar{\n    \n    cursor: pointer;\n    \n}\n.hero-search-modified .category_div {\n    padding: 0px 30px;\n}\n/* .dropdown:hover>.dropdown-menu {\n  display: block;\n  max-height: 300px;\n} */\n.dropdown>.dropdown-toggle:active {\n  /*Without this, clicking will make it sticky*/\n    /* pointer-events: none; */\n}\n\n.dropdown-toggle::after {\n  display: none;\n}\n.hero-search-modified.inner-page .dropdown-menu::before {\n    content: \"\";\n    width: 100%;\n    height: 30px;\n    background: transparent;\n    position: absolute;\n    top: -30px;\n}\n.search-bar .form-control {\n    border: 1.5px solid rgba(122, 137, 146, 0.5);\n    border-radius: 8px;\n    height: 40px;\n    padding-left: 50px;\n    padding-right: 30px;\n}\n\n.form-control:focus {\n  border-color:rgba(122, 137, 146, 0.5) !important; /* Set the desired border color on focus */\n  \n}\n.search-bar {\n    position: relative;\n    width: 100%;\n    margin-right: 15px;\n    /* max-width: 630px; */\n    max-width: 100%;\n}\n.search-bar .search-icon {\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    color: #333;\n    left: 20px;\n    font-size: 14px;\n}\n.search-content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n.search-bar .form-control::placeholder {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: rgba(126, 133, 142, 0.6);\n    opacity: 0.8;\n} \n.categories-search {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.categories-searchh {\n    display: flex;\n    align-items: center;\n    /* justify-content: center; */\n    margin-bottom: 5px;\n}\n.categories-area {\n    display: flex;\n    align-items: center;\n    flex-wrap: wrap;\n    overflow-y: auto;\n    max-height: 400px;\n}\n\n.category-btn {\n    font-weight: 600;\n    font-size: 16px;\n    line-height: 24px;\n    color: #fff;\n    min-width: 150px;\n    /* text-align: strat; */\n    margin-bottom: 10px;\n    cursor: pointer;\n}\n.category-bttn {\n    font-weight: 400;\n    font-size: 14px;\n    line-height: 24px;\n    color: #fff;\n    min-width: 150px;\n    /* text-align: strat; */\n    /* margin-bottom: 10px; */\n    cursor: pointer;\n}\n.category-bttnn{\n    font-weight: 400;\n    font-size: 15px;\n    line-height: 24px;\n    /* min-width: 150px; */\n    /* text-align: strat; */\n    margin-bottom: 15px;\n    cursor: pointer;\n}\n\n.btn.category-btn:hover {\n    color: var(--blue)!important;\n}\n.category-btn i {\n    font-size: 10px;\n    margin-left: 10px;\n}\n.categories-search {\n    margin-top: 15px;\n}\n.container{\n    /* background-color: rgba(0,0,0,0.5); */\n  z-index: 2;\n}\n\n/*==== Min Width media query ====*/\n\n@media only screen and (min-width: 576px){\n\n}\n\n@media only screen and (min-width: 768px){\n  \n}\n\n@media only screen and (min-width: 992px){\n .category-modal .modal-dialog {\n        max-width: 652px;\n } \n}\n\n@media only screen and (min-width: 1201px){\n  \n}\n\n/*==== Min & Max Width media query ====*/\n@media only screen and (min-width: 767px) and (max-width: 1200px){\n  .listing-bottom-right h6 {\n        font-size: 18px;\n    }\n    .listing-bottom-right h6 span{\n        font-size: 18px!important;\n    }\n  .listing-bottom-right-giftcards h6 {\n        font-size: 18px;\n    }\n    .listing-bottom-right-giftcards h6 span{\n        font-size: 18px!important;\n    }\n    .inputwithunit .form-control, .inputwithunit span {\n        font-size: 16px;\n    }\n}\n\n/*==== Max Width media query ====*/\n\n@media only screen and (max-width: 1200px){\n  \n}\n\n@media only screen and (max-width: 991px){\n}\n\n@media only screen and (max-width: 767px){ \n}\n\n@media only screen and (max-width: 575px){\n\n}\n@media screen and (min-width:992px) and (max-width:1200px) {\n    .category-btn{\n        margin-bottom: 60px !important;\n        margin-right: 87px !important;\n    } \n}\n\n@media only screen and (max-width: 425px){\n.search-content {\n    display: block;\n}\n.search-content .btn {\n    width: 100%;\n    margin-top: 10px;\n}\n.category-btn {\n    text-align: center;\n}\n}\n.dropdown {\n    position: relative;\n    display: inline-block;\n}\n\n.dropdown-content {\n    display: none;\n    position: absolute;\n    background-color: #f9f9f9;\n    min-width: 200px;\n    box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);\n    padding: 10px;\n    z-index: 1;\n    grid-template-columns: repeat(2, 1fr);\n    grid-template-rows: repeat(10, auto);\n    grid-gap: 5px;\n    list-style: none;\n}\n\n.dropdown:hover .dropdown-content {\n    display: grid;\n}\n\n.dropdown-content a {\n    color: black;\n    padding: 8px 16px;\n    text-decoration: none;\n    display: block;\n}\n\n.dropdown-content a:hover {\n    background-color: #f1f1f1;\n}\n\n@media (max-width: 576px) {\n    .dropdown-content {\n        max-height: 400px; \n        min-width: 100%; \n        display: block; \n        grid-template-columns: none;\n        grid-template-rows: none; \n        overflow: auto;\n    }\n    .dropdown-content li {\n        display: block; \n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
